import React from "react";

// components
import TextInput from "../../../components/elements/form/TextInput";
import Button from "../../../components/elements/form/Button";

// state
import { shareDocument } from "../../../service/api/document";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../components/ui/modal";

const SendFIle = ({ document_id, visible, onSubmit }) => {
  const dispatch = useDispatch();
  const [email, emailSet] = React.useState("");
  const [error, errorSet] = React.useState("");
  const loading = useSelector(({ loading }) => loading?.update);

  const onSubmitRequest = async () => {
    if (email && document_id) {
      const response = await shareDocument(dispatch, {
        email,
        document_id,
      });
      if (response) {
        onSubmit?.();
      }
    }
  };

  return (
    <Modal
      open={visible}
      // onCancel={onSubmit}
      onClose={onSubmit}
    >
      <div className="space-y-6 mt-8 md:mt-0">
        <TextInput
          label=" Enter recipient Corporate Email"
          name="email"
          value={email}
          onChange={(e) => {
            emailSet(e.target.value);
            errorSet("");
          }}
          status={error}
          placeholder="Email"
          type="email"
        />
        <Button
          title="Send"
          loading={loading}
          className="bg-primary-500 hover:bg-primary-900 rounded-lg text-white"
          onHandler={onSubmitRequest}
          rightIcon={null}
        />
      </div>
    </Modal>
  );
};

export default SendFIle;
